export const PRODUCT_INFORMATION = 'information';
export const PRODUCT_ATTRIBUTES = 'attributes';
export const PRODUCT_REVIEWS = 'reviews';
export const PRODUCT_CUSTOM_PLACEMENT = 'custom_placement';
export const PRODUCT_QUALITY_SYMBOLS = 'quality_symbols';
